import { HStack, Flex, cssVar, Box, IconButton, Text } from '@cad-arc';
import { FR_HEADER_HEIGHT } from './constants';
import { GenericObject } from '../common/types';
import { useGoBackToPreviousFirstResponderPage } from '../common/hooks/use-go-back-to-previous-first-responder-page';
import { FederatedSearchMoreActionsMenu } from '../federated-search/dex-next-results-more-actions-menu';

export function FrPageHeader(props: {
    children?: React.ReactNode;
    title: string | React.ReactNode;
    customStyles?: GenericObject<string | number>;
    complementaryContent?: React.ReactNode;
    showGoBackButton?: boolean;
    showMoreActionsMenu?: boolean;
    onGoBack?: () => void;
}) {
    const horizontalPadding = props?.showGoBackButton ? 0 : 3;
    const goBackToPreviousFirstResponderPage = useGoBackToPreviousFirstResponderPage(
        props.onGoBack
    );

    const borderStyles = {
        borderBottomWidth: '1px',
        borderBottomColor: 'border.default',
    };

    const titleElement = (
        <Text variant="headingLg" style={{ whiteSpace: 'nowrap' }}>
            {props.title}
        </Text>
    );

    const commonContent = (
        <HStack
            w="100%"
            alignItems="center"
            px={horizontalPadding}
            style={props.customStyles ?? {}}
        >
            {props.showMoreActionsMenu ? (
                <Box
                    display="flex"
                    justifyContent="space-between"
                    flexGrow={1}
                    alignItems="center"
                    alignSelf="center"
                >
                    {titleElement}
                    <FederatedSearchMoreActionsMenu />
                </Box>
            ) : (
                titleElement
            )}
            {props.children}
        </HStack>
    );

    const headerMainContent = (
        <Flex
            direction="column"
            justifyContent="center"
            backgroundColor={cssVar('arc.colors.surface.foreground')}
            width="full"
            {...(props?.showGoBackButton
                ? {}
                : {
                      minH: `${FR_HEADER_HEIGHT}px`,
                      ...borderStyles,
                  })}
        >
            {props?.complementaryContent ? (
                <>
                    {commonContent}
                    <HStack px={horizontalPadding}>{props.complementaryContent}</HStack>
                </>
            ) : (
                commonContent
            )}
        </Flex>
    );

    if (!props?.showGoBackButton) {
        return headerMainContent;
    }

    return (
        <HStack
            data-testid="fr-page-header"
            w="100%"
            minH={`${FR_HEADER_HEIGHT}px`}
            backgroundColor={cssVar('arc.colors.surface.foreground')}
            {...borderStyles}
        >
            <Flex padding="0 5px" alignItems="center" justifyContent="center">
                <IconButton
                    variant="ghost"
                    icon="ArrowLeft"
                    aria-label="Go back"
                    onClick={goBackToPreviousFirstResponderPage}
                />
            </Flex>
            {headerMainContent}
        </HStack>
    );
}
